import { CountryCode } from '@/constants/countryCodes';
import { FeatureFlag } from '@/constants/featureFlags';
import { StateCode } from '@/constants/states';
import type { Customer } from '@/types/checkout';

const COUNTRIES_WITH_ADDRESS_FIELD_FOR_TAX_CALCULATION = [CountryCode.USA, CountryCode.CANADA];

export const isCountryCodeIsUSAOrCanada = (countryCode: string) => {
  return COUNTRIES_WITH_ADDRESS_FIELD_FOR_TAX_CALCULATION.includes(countryCode as CountryCode);
};

export const isCountryCodeUSA = (countryCode: string) => {
  return countryCode === CountryCode.USA;
};

export const isCaliforniaState = (stateCode: string) => {
  return stateCode === StateCode.CALIFORNIA;
};

export const shouldShowAddressFieldForTaxCalculation = (
  customer: Customer,
  featureFlags: Record<FeatureFlag, boolean>
) => {
  return (
    isCountryCodeIsUSAOrCanada(customer.taxCountry ?? customer.geoLocator?.countryCode2 ?? '') &&
    featureFlags[FeatureFlag.COLLECT_FULL_ADDRESS]
  );
};

export const shouldShowZipCodeFieldForTaxCalculation = (customer: Customer) => {
  return isCountryCodeIsUSAOrCanada(customer.taxCountry ?? customer.geoLocator?.countryCode2 ?? '');
};
